export const FETCH_CONCIERGE_REQUEST = 'FETCH_CONCIERGE_REQUEST';
export const FETCH_CONCIERGE_SUCCESS = 'FETCH_CONCIERGE_SUCCESS';
export const FETCH_CONCIERGE_FAILURE = 'FETCH_CONCIERGE_FAILURE';

